import { NavigateFunction } from 'react-router-dom'

import * as variable from 'utils/Variable'
import * as paths from 'utils/Links'

export const handleHttpErrorRedirect = (errorResponseCode: number, navigate: NavigateFunction): void => {
  if (errorResponseCode > 0 && errorResponseCode !== variable.httpStatusCodes.internalServerError) {
    const alertLevel: string = errorResponseCode === variable.httpStatusCodes.conflict ? 'warning' : 'error'

    const errorTitle: string =
      errorResponseCode === variable.httpStatusCodes.notFound ? "Oops! This link isn't valid." : 'Oops!'

    let errorHeading: string

    switch (errorResponseCode) {
      case variable.httpStatusCodes.notFound:
        errorHeading = 'Please double check the link and try again or get a quote.'
        break
      case variable.httpStatusCodes.conflict:
        errorHeading = "You've already applied for this loan."
        break
      default:
        errorHeading = "There's been a problem with our system."
    }

    navigate(paths.getHttpStatusErrors().replace(':statusCode', `${errorResponseCode}`), {
      state: {
        alertLevel,
        message: errorHeading,
        title: errorTitle,
        isRedirectEnabled: true,
        redirectPageTitle: 'Dashboard',
        redirectPath: paths.getDashboard(),
        redirectCountdown: 60,
      },
    })
  }
}
